/**
 * Created by Angelika on 02.11.2017.
 */
import React from 'react';
import * as strings from '../constants/strings';

const NotFound = ({addMsg}) => (
    <div id="not-found">
        <h3>{strings.PAGE_NOT_FOUND_TITLE}</h3>
        <p>{addMsg ? addMsg : strings.PAGE_NOT_FOUND_MSG}</p>
    </div>
);

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.js